import { createSlice } from '@reduxjs/toolkit';
import {
  PREVIEW_CHECKLIST,
  ADD_CHECKLIST,
  UPDATE_CHECKLIST
} from '../constants/constants';

const initialState = {
  hasBeenPreviewed: false,
  hasBeenSubmited: false,
  data: {}
};

const checklistPreviewSlice = createSlice({
  name: 'checklist',
  initialState,
  reducers: {
    resetPreview: () => initialState
  },
  extraReducers: builder => {
    builder
      .addCase(PREVIEW_CHECKLIST, (state, action) => {
        state.data = action.data;
        state.hasBeenPreviewed = true;
      })
      .addMatcher(
        action => action.type === ADD_CHECKLIST || action.type === UPDATE_CHECKLIST,
        state => {
          state.hasBeenSubmited = true;
        }
      );
  }
});

export const { resetPreview } = checklistPreviewSlice.actions;
export default checklistPreviewSlice.reducer;
